var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useCallback } from 'react';
import { DoubleLeftOutlined } from '@ant-design/icons'; //TODO: replace it
import { Button } from '../Buttons';
import { Container } from './styled';
import { useLocation } from 'react-router';
export var Direction;
(function (Direction) {
    Direction[Direction["top"] = 0] = "top";
    Direction[Direction["bottom"] = 1] = "bottom";
})(Direction || (Direction = {}));
var ScrollTopBottom = function (_a) {
    var containerRef = _a.containerRef, onClickScroll = _a.onClickScroll;
    var _b = __read(useState(Direction.bottom), 2), direction = _b[0], changeDirection = _b[1];
    var _c = __read(useState(false), 2), visible = _c[0], setVisible = _c[1];
    var pathname = useLocation().pathname;
    useEffect(function () {
        setVisible(false);
    }, [pathname]);
    useEffect(function () {
        var target = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
        if (!target)
            return;
        var onScroll = function () {
            var scrollTop = target.scrollTop || 0;
            var halfScroll = ((target.scrollHeight || 0) - (target.offsetHeight || 0)) / 2;
            setVisible(target.scrollTop !== 0 && target.scrollHeight !== target.clientHeight);
            changeDirection(scrollTop > halfScroll ? Direction.top : Direction.bottom);
        };
        target.addEventListener('scroll', onScroll);
        return function () { return target.removeEventListener('scroll', onScroll); };
    }, [containerRef]);
    var handleClick = useCallback(function () {
        var _a;
        if (onClickScroll)
            return onClickScroll(containerRef, direction);
        (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
            top: direction === Direction.top ? 0 : containerRef === null || containerRef === void 0 ? void 0 : containerRef.current.scrollHeight,
            behavior: 'smooth',
        });
    }, [direction, containerRef, onClickScroll]);
    return (React.createElement(Container, { direction: direction, isHidden: !visible },
        React.createElement(Button, { type: 'primary', title: direction === Direction.top ? 'Наверх' : 'Вниз', htmlType: 'button', icon: React.createElement(DoubleLeftOutlined, null), onClick: handleClick })));
};
export default ScrollTopBottom;
//# sourceMappingURL=ScrollTopBottom.js.map